// extracted by mini-css-extract-plugin
module.exports = {"content":"UserDetailHeader_content__1EMsc","sending":"UserDetailHeader_sending__2sMXw"};